import { PriorityForm, PriorityListTable } from "./components";

import { useTicketPrioritySettings } from "@hooks/tickets/ticket-settings/useTicketPrioritySettings";

const Priority = () => {
  const data = useTicketPrioritySettings();

  return (
    <>
      <PriorityForm data={data} />
      <PriorityListTable data={data} />
    </>
  );
};

export default Priority;
